import { UserLanguages } from '@cnx-saas/common';
import { Shipment } from './Shipment';
import { ShipmentAssignmentPayload } from './ShipmentAssignment';
import { Shipper } from './Shipper';

export type EmailAttachment =
  | {
      filename: string;
      path: string;
    }
  | {
      filename: string;
      content: string;
      encoding: 'base64';
    };

export type EmailOptions = {
  to: string;
  subject: string;
  attachments: EmailAttachment[];
};

export type TransportOrderProps = {
  carrierCompanyName: string;
  carrierDispatcherName?: string;
  shipperCompanyName: string;
  solutionProvider: string;
  anonymousLink: string;
  preferredLanguage: UserLanguages;
  applicationDeadline?: Date;
};

export type TransportOrderRejectProps = {
  carrierDispatcherName: string;
  shipperCompanyName: string;
  solutionProvider: string;
  preferredLanguage: UserLanguages;
};

export type TransportOrderRevokeProps = {
  carrierDispatcherName: string;
  shipperCompanyName: string;
  solutionProvider: string;
  preferredLanguage: UserLanguages;
};

export type TransportOrderReminderProps = {
  carrierDispatcherName: string;
  shipperCompanyName: string;
  solutionProvider: string;
  anonymousLink: string;
  remainingHours: number;
  preferredLanguage: UserLanguages;
};

export type TransportOrderDocumentProps = {
  assignment: ShipmentAssignmentPayload;
  shipment: Shipment;
  shipper: Shipper;
  isDraft?: boolean;
  logoUrl?: string | null;
  isCanceled?: boolean;
};

export const TransportOrderEmailSender = {
  from: '"Cargonexx GmbH" <support@cargonexx.de>',
  replyTo: 'support@cargonexx.de',
  subject: 'Transportauftrag von',
  subjectEn: 'Transportation by',
};
export const TransportOrderRequestEmailSender = {
  from: '"Cargonexx GmbH" <support@cargonexx.de>',
  replyTo: 'support@cargonexx.de',
  subject: 'Transportanfrage von',
  subjectEn: 'Transport request by',
};
export const TransportOrderRevokeEmailSender = {
  from: '"Cargonexx GmbH" <support@cargonexx.de>',
  replyTo: 'support@cargonexx.de',
  subject: 'Stornierung der Anfrage',
  subjectEn: 'Cancellation of request',
};
export const TransportOrderCanceledEmailSender = {
  from: '"Cargonexx GmbH" <support@cargonexx.de>',
  replyTo: 'support@cargonexx.de',
  subject: 'Auftragsstornierung',
  subjectEn: 'Transport order cancelation',
};

export const TransportOrderEmailSenderTimeout = {
  from: '"Cargonexx GmbH" <support@cargonexx.de>',
  replyTo: 'support@cargonexx.de',
  subject: 'Abbruch Transportanfrage von',
  subjectEng: 'Cancelation Transport request from',
};

export const transportOrderEmailSenderReminder = (
  reminderCount: number,
  preferredLanguage: UserLanguages,
  shipperCompanyName: string,
) => {
  return {
    from: '"Cargonexx GmbH" <support@cargonexx.de>',
    replyTo: 'support@cargonexx.de',
    subject:
      preferredLanguage === UserLanguages.DE
        ? `${reminderCount}. Erinnerung Transportanfrage von ${shipperCompanyName}`
        : `${reminderCount}. reminder transport request from ${shipperCompanyName}`,
  };
};

export const TransportOrderReminder = {
  timeoutHours: 12,
  reminderHours: 3,
  noOfReminders: 3,
};
